import { render, staticRenderFns } from "./DividerComponent.vue?vue&type=template&id=65e4ca1b&scoped=true"
import script from "./DividerComponent.vue?vue&type=script&lang=js"
export * from "./DividerComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e4ca1b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65e4ca1b')) {
      api.createRecord('65e4ca1b', component.options)
    } else {
      api.reload('65e4ca1b', component.options)
    }
    module.hot.accept("./DividerComponent.vue?vue&type=template&id=65e4ca1b&scoped=true", function () {
      api.rerender('65e4ca1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/entries/formComponents/style-components/DividerComponent.vue"
export default component.exports